import React from "react";
import Hero from "../Components/Hero/Hero";
import About from "../Components/About/About";
import Mission from "../Components/Mission/Mission";
import HowItWorks from "../Components/HowItWorks/HowItWorks";
import Features from "../Components/Features/Features";
import PortalAccess from "../Components/PortalAccess/PortalAccess";
import Pricing from "../Components/Pricing/Pricing";
import Cancellation from "../Components/Cancellation/Cancellation";
import ContactSection from "../Components/ContactSection/ContactSection";
import FAQSection from "../Components/FAQSection/FAQSection";
// import PortalButton from "../Components/PortalButton/PortalButton";



const Home = () => {
  return (
    <>
      <Hero />
      <About />
      <Mission />
      <HowItWorks />
      <Features />
      <PortalAccess />
      <Pricing />
      <Cancellation />
      <ContactSection />
      <FAQSection />
      {/* <PortalButton />
      */}
    </>
  );
};

export default Home;
